import { z } from "zod";
import { EMPLOYEE_STATUSES } from "../enums.js";
import { assignmentSummarySchema } from "./auth.js";
import { isoDateSchema, isoTimestampSchema } from "./common.js";

export const employeesQuerySchema = z.object({
  q: z.string().trim().max(100).optional(),
  active: z.enum(["true", "false"]).optional(),
});
export type EmployeesQuery = z.infer<typeof employeesQuerySchema>;

export const employeeRowSchema = z.object({
  zvEmployeeId: z.number().int(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  personnelNo: z.number().int().nullable(),
  status: z.enum(EMPLOYEE_STATUSES),
  isActive: z.boolean(),
  entryDate: isoDateSchema.nullable(),
  exitDate: isoDateSchema.nullable(),
  officeId: z.number().int(),
  syncedAt: isoTimestampSchema,
  login: z
    .object({
      userId: z.string(),
      // Login channels (extension 3): e-mail (magic link), phone (SMS code) or both.
      email: z.string().nullable(),
      phone: z.string().nullable(),
      isActive: z.boolean(),
      lastLoginAt: isoTimestampSchema.nullable(),
    })
    .nullable(),
  assignments: z.array(assignmentSummarySchema),
});
export type EmployeeRow = z.infer<typeof employeeRowSchema>;

export const employeesResponseSchema = z.object({ employees: z.array(employeeRowSchema) });
export type EmployeesResponse = z.infer<typeof employeesResponseSchema>;

export const employeeIdParamsSchema = z.object({ id: z.coerce.number().int().positive() });

// The invitation goes by e-mail (magic link) when the login has one, else by SMS (extension 3).
export const inviteResponseSchema = z.object({
  ok: z.literal(true),
  channel: z.enum(["email", "sms"]),
  email: z.string().nullable(),
  phone: z.string().nullable(),
});
export type InviteResponse = z.infer<typeof inviteResponseSchema>;
